// CandidatesHiringAnalysis.jsx
import React, { useState, useRef, useEffect } from "react";
import { Card } from "react-bootstrap";
import { FiSliders, FiDownload } from "react-icons/fi";

const data = [
  { title: "Marketing", sub: "Product Manager", a: 14, s: 8 },
  { title: "Data Analyst", sub: "Jr Data Analyst", a: 16, s: 12 },
  { title: "Project Coordinator", sub: "Jr Level", a: 24, s: 6 },
  { title: "Design Lead", sub: "UI Designer", a: 12, s: 8, i: 6, o: 5 },
  { title: "Project Manager", sub: "Senior Manager", a: 22, s: 20, i: 16, o: 12, h: 4 },
];

export default function CandidatesHiringAnalysis() {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <Card className="cha-card">
      <Card.Body>

        {/* HEADER */}
        <div className="cha-header">
          <h5 className="cha-title">Candidates Hiring Analysis</h5>

          <div className="cha-header-right" ref={ref}>
            <div className="cha-filter-btn" onClick={() => setOpen(!open)}>
              <FiSliders />
            </div>

            {open && (
              <div className="cha-dropdown">
                <p>Daily Report</p>
                <p>Weekly Report</p>
                <p>Monthly Report</p>
                <p>Yearly Report</p>
              </div>
            )}

            <div className="cha-last">
              <FiDownload /> Last 30 Days
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="cha-table">

          {/* HEADER */}
          <div className="cha-head">
            <span>Department</span>
            <span>Applicants</span>
            <span>Shortlisted</span>
            <span>Interviewed</span>
            <span>Offered</span>
            <span>Hired</span>
          </div>

          {/* ROWS */}
          {data.map((item, i) => (
            <div className="cha-row" key={i}>
              <div className="cha-dept">
                <p className="cha-main">{item.title}</p>
                <span className="cha-sub">{item.sub}</span>
              </div>

              <div className="cha-pill cha-orange">{item.a}</div>
              <div className="cha-pill cha-teal">{item.s}</div>
              <div className="cha-pill cha-dark">{item.i || ""}</div>
              <div className="cha-pill cha-blue">{item.o || ""}</div>
              <div className="cha-pill cha-green">{item.h || ""}</div>
            </div>
          ))}

        </div>

      </Card.Body>

      {/* ================= UNIQUE CSS ================= */}
      <style>{`

        .cha-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          padding: 10px;
        }

        /* HEADER */
        .cha-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .cha-title {
          font-weight: 600;
          margin: 0;
        }

        .cha-header-right {
          display: flex;
          align-items: center;
          gap: 12px;
          position: relative;
        }

        .cha-filter-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #f3f4f6;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .cha-last {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 14px;
          color: #374151;
        }

        /* DROPDOWN */
        .cha-dropdown {
          position: absolute;
          top: 50px;
          right: 0;
          background: #fff;
          border-radius: 10px;
          width: 180px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          overflow: hidden;
          z-index: 10;
        }

        .cha-dropdown p {
          padding: 10px 15px;
          margin: 0;
          cursor: pointer;
        }

        .cha-dropdown p:hover {
          background: #f3f4f6;
        }

        /* TABLE */
        .cha-table {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }

        .cha-head {
          display: grid;
          grid-template-columns: 2.5fr repeat(5, 1fr);
          font-weight: 600;
          color: #374151;
          font-size: 14px;
        }

        .cha-row {
          display: grid;
          grid-template-columns: 2.5fr repeat(5, 1fr);
          align-items: center;
        }

        .cha-main {
          margin: 0;
          font-weight: 500;
        }

        .cha-sub {
          font-size: 13px;
          color: #9ca3af;
        }

        /* PILLS (NO CONFLICT) */
        .cha-pill {
          height: 38px;
          width: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 15px;
          font-weight: 600;
          font-size: 14px;
          border: none !important;
        }

        .cha-orange { background: #f26522; color: #fff; }
        .cha-teal   { background: #0f4c5c; color: #fff; }
        .cha-dark   { background: #1f2937; color: #fff; }
        .cha-blue   { background: #2f80ed; color: #fff; }
        .cha-green  { background: #16c172; color: #fff; }

        /* EMPTY GREY */
        .cha-pill:empty {
          background: #e5e7eb;
        }

        /* MOBILE */
        @media (max-width: 768px) {

          .cha-head {
            display: none;
          }

          .cha-row {
            grid-template-columns: 1fr;
            gap: 10px;
            background: #f9fafb;
            padding: 12px;
            border-radius: 10px;
          }

          .cha-pill {
            width: 100%;
          }
        }

      `}</style>
    </Card>
  );
}